import React, { useState } from "react";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { FiMinusCircle } from "react-icons/fi";
import { LiaPlusCircleSolid } from "react-icons/lia";

import { SlArrowUp } from "react-icons/sl";
import { MdOutlineDeleteOutline } from "react-icons/md";
import { useNavigate } from "react-router-dom";


import defaultimg from "../../Assets/Images/default-placeholder.png";
import vegIcon from "../../Assets/Images/vegpngoutput.png"
import nonvegIcon from "../../Assets/Images/nomvegoutput.png"
import eggIcon from "../../Assets/Images/eggpngoutput.png"
import SelectShippingOffCanvas from "../offCanvas/selectShippingOffCanvas";

const SearchProductCard = ({ data, forCart }) => {
    const navigate = useNavigate();
    const [showModel, setShowModel] = useState(false)


    const toggleOffCanvas = () => {
        setShowModel(!showModel)
    }

    // console.log('data-------', data);
    // console.log('forCart-------', forCart);

    let merchantid = forCart?.vendor_id;
    return (
        <>
            <div className="componentProductCard ProductServiceCardMedium">
                <div className="productCardContainer">
                    <div className="productCardBody ">
                        <div className=" ">
                            <img src={data?.image_url || defaultimg}
                                className="productImageMedium"
                                onError={(e) => (e.currentTarget.src = defaultimg)}
                            />
                        </div>

                        <div className="productDetails  ">
                            <div className="productName fs-12">
                                {data?.food_type && data?.food_type != 0 &&
                                    <img src={data?.food_type == "1" ? vegIcon : data?.food_type == "2" ? nonvegIcon : data?.food_type == "3" ? eggIcon : ""}
                                        height="13px" width="13px" className="me-2 foodTypeImg" />}
                                {
                                data?.product_name ? 
                                data?.product_name:
                                data?.name?.length > 18
                                    ? data.name.slice(0, 18) + "..."
                                    : data.name}
                            </div>

                            <div className="price fs-10">
                                <span className="rupeeIcon">₹</span>{data?.price}
                            </div>

                            {/* <div className="unitType fs-10">
                            {data.unit_type} {data.unit_type_name}
                        </div> */}

                            <div className="moreDetails d-flex align-items-center fs-10"
                                onClick={() => navigate(`/product/${merchantid}/${data.product_id}`, { state: { productId: data.product_id, merchantid,flow:'ProductSearch' } })}
                            >
                                <span>More details</span>
                                <IoIosArrowDown size={16} />
                            </div>

                            {
                                data?.added_count ?
                                    <div className="d-flex justify-content-between  align-items-center mt-1">
                                        <div className="productAddorRemove">
                                            <FiMinusCircle size={20} />
                                            <span>{data?.added_count} 1</span>
                                            <LiaPlusCircleSolid size={21} />
                                        </div>
                                        <MdOutlineDeleteOutline size={20} color="red" />
                                    </div>
                                    :
                                    <div className="d-flex justify-content-end  " onClick={() => toggleOffCanvas()}>
                                        <button className="productSelectBtn  ">
                                            Select
                                        </button>
                                    </div>
                            }

                            {/* {
                            data.added_count ? (
                                <div className="d-flex justify-content-between  align-items-center mt-1">
                                    <div className="productAddorRemove">
                                        <FiMinusCircle size={20} />
                                        <span>{data.added_count} 1</span>
                                        <LiaPlusCircleSolid size={21} />
                                    </div>

                                    <MdOutlineDeleteOutline size={20} color="red" />
                                </div>
                            ) : (
                                <div className="d-flex justify-content-between  ">
                                    <div className="moreDetails fs-10 d-flex align-items-start">
                                        <div className="d-flex align-items-center">

                                            <span>More details</span>
                                            <IoIosArrowDown size={17} />
                                        </div>
                                    </div>

                                    <button className="productSelectBtn mt-">
                                        Select
                                    </button>
                                </div>
                            )
                        } */}



                        </div>

                    </div>
                </div>
            </div>
            {
                showModel &&
                <SelectShippingOffCanvas isOpen={showModel} toggleOffCanvas={toggleOffCanvas} forCart={forCart} data={data} />
            }
        </>
    )
}
export default SearchProductCard;